module.exports = __webpack_public_path__ + "img/tg_icon.6251a910.svg";